import React from 'react';
import './App.scss';
import { ThemeProvider } from '@emotion/react';
import { appTheme } from './theme/theme';
import { CssBaseline } from '@mui/material';
import { BrowserRouter, HashRouter, Route, Routes } from 'react-router-dom';
import Login from './Login/Login';
import 'bootstrap/dist/css/bootstrap.min.css';
import Dashboard from './dashboard/dashboard';
import { Provider } from 'react-redux';
import store from './store';
import PrivateRoutes from './privateRoutes';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import 'mapbox-gl/dist/mapbox-gl.css';


function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={appTheme}>
        <CssBaseline enableColorScheme />
        <HashRouter>
          <Routes>
            <Route path='/login' element={<Login />}></Route>
            <Route path='/dashboard' element={
              <PrivateRoutes>
                <Dashboard />
              </PrivateRoutes>
            } />
            <Route path='/' element={<Login />}></Route>
          </Routes>

        </HashRouter>
      </ThemeProvider>
    </Provider>

  );
}

export default App;
